import { space } from 'styled-system';
import styled from '../../../libs/styled.es.js';

const Container = styled.div(space, ({ fluid }) => {
  const styles = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  };
  if (!fluid) {
    styles.maxWidth = "1264px";
  }
  return styles;
});

export { Container };
